import * as Yup from 'yup';

export const schema = Yup.object().shape(
  {
    startDate: Yup.string()
      .nullable()
      .when('endDate', {
        is: (value) => value !== null,
        then: Yup.string().required('Please enter Date From'),
        otherwise: Yup.string(),
      }),
    endDate: Yup.string()
      .nullable()
      .when('startDate', {
        is: (value) => value !== null,
        then: Yup.string().required('Please enter Date To'),
        otherwise: Yup.string(),
      }),
  },
  [['startDate', 'endDate']]
);
